import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { PacoteCampanhaSelectComponent } from './pacote-campanha-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PacoteCampanhaSelectComponent
    ],
    exports: [
        PacoteCampanhaSelectComponent
    ]
})
export class PacoteCampanhaSelectModule { }
